import React from "react";
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { SEGMENT_FIELD_TYPES } from "../segmentRegistry";
import { getValueAtDescriptorPath } from "../elementEditing";

export default function NavbarMobileElementEditor({ descriptor, form, disabled, onCommit }) {
  const fields = descriptor?.fields || [];
  return (
    <Stack spacing={1.1}>
      <Typography variant="body2" sx={{ color: "rgba(25,36,47,.62)" }}>Los valores vacíos siguen heredando la configuración de escritorio.</Typography>
      {fields.map((field) => {
        const value = getValueAtDescriptorPath(form, field.path, "");
        if (field.type === SEGMENT_FIELD_TYPES.SELECT) return <FormControl key={field.path} fullWidth size="small" disabled={disabled}><InputLabel>{field.label}</InputLabel><Select label={field.label} value={value ?? ""} onChange={(event) => onCommit?.(field.path, event.target.value)}>{(field.options || []).map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}</Select></FormControl>;
        return <TextField key={field.path} fullWidth size="small" type={field.type === SEGMENT_FIELD_TYPES.NUMBER ? "number" : "text"} label={field.label} value={value ?? ""} disabled={disabled} onChange={(event) => onCommit?.(field.path, field.type === SEGMENT_FIELD_TYPES.NUMBER && event.target.value !== "" ? Number(event.target.value) : event.target.value)} />;
      })}
    </Stack>
  );
}
